import { Link } from "react-router-dom";
import "./Menu.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { clearAuth, getAuthToken, getTokenUserId } from "../../utils/auth";

const Menu = () => {
  const [backgroundImg, setBackgroundImg] = useState(null);
  const [backgroundError, setBackgroundError] = useState("");
  const [isSavingBackground, setIsSavingBackground] = useState(false);
  const [loggedUser, setLoggedUser] = useState(null);
  const navigate = useNavigate();
  const token = getAuthToken();

  const handleLogged = async () => {
    try {
      const userId = getTokenUserId(token);
      if (!userId) {
        throw new Error("Token sem identificação de usuário.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        `https://www.euvoup14sports.com.br/api/user/${userId}`,
        {},
        config
      );
      setLoggedUser(response.data?.data || null);
    } catch (error) {
      handleLogout();
      clearAuth();
      navigate("/login");
    }
  };
  useEffect(() => {
    if (token) {
      handleLogged();
    } else {
      navigate("/login");
    }
  }, [token, navigate]);

  const handleLogout = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    try {
      await axios.post(
        `https://www.euvoup14sports.com.br/api/logout`,
        {},
        config
      );
    } catch (error) {
      console.error("Erro ao salvar evento", error);
    }
    clearAuth();
    setLoggedUser(null);
  };

  const handleEventoClickBackground = () => {
    setBackgroundError("");
    setBackgroundImg({ file: null, previewUrl: "" });
  };

  const closeBackgroundModal = () => {
    if (isSavingBackground) return;

    setBackgroundError("");
    setBackgroundImg(null);
  };

  const handleBackgroundFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const supportedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!supportedTypes.includes(file.type)) {
      setBackgroundError("Selecione uma imagem JPG, PNG ou WEBP.");
      event.target.value = "";
      return;
    }

    const maxFileSize = 8 * 1024 * 1024;
    if (file.size > maxFileSize) {
      setBackgroundError("A imagem deve ter no máximo 8 MB.");
      event.target.value = "";
      return;
    }

    setBackgroundError("");
    setBackgroundImg({ file, previewUrl: URL.createObjectURL(file) });
  };

  useEffect(() => {
    const previewUrl = backgroundImg?.previewUrl;

    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [backgroundImg?.previewUrl]);

  const handleSalvar = async () => {
    if (!backgroundImg?.file) {
      setBackgroundError("Selecione uma imagem antes de salvar.");
      return;
    }

    const dataToSend = new FormData();
    dataToSend.append("file", backgroundImg.file);

    setBackgroundError("");
    setIsSavingBackground(true);

    try {
      await axios.post(
        "https://www.euvoup14sports.com.br/api/background",
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("Imagem salva com sucesso!");
      setBackgroundImg(null);
    } catch (error) {
      console.error("Erro ao salvar imagem de fundo", error);
      setBackgroundError(
        error.response?.data?.message ||
          "Não foi possível salvar a imagem. Tente novamente."
      );
    } finally {
      setIsSavingBackground(false);
    }
  };

  return (
    <>
      <header className="admin-topbar">
        <div className="admin-topbar-inner">
          <Link to="/admin" className="admin-topbar-brand" aria-label="Painel P14 Sports">
            <span>P14</span>
            <strong>Sports Admin</strong>
          </Link>

          <nav className="admin-topbar-nav" aria-label="Navegação administrativa">
            <Link to="/eventos" className="admin-topbar-link">
              <span aria-hidden="true">↗</span>
              Página pública
            </Link>
            <button
              type="button"
              className="admin-topbar-link"
              onClick={handleEventoClickBackground}
            >
              <span aria-hidden="true">◫</span>
              Alterar fundo
            </button>
            <div className="admin-topbar-user" aria-live="polite">
              <span aria-hidden="true">
                {loggedUser?.name?.trim()?.charAt(0)?.toUpperCase() || "…"}
              </span>
              <div>
                <small>Sessão ativa</small>
                <strong>
                  {loggedUser?.name
                    ? `Usuário ${loggedUser.name}`
                    : "Validando usuário..."}
                </strong>
              </div>
            </div>
            <Link
              to="/login"
              className="admin-topbar-logout"
              onClick={handleLogout}
            >
              Sair
            </Link>
          </nav>
        </div>
      </header>

      {backgroundImg && (
        <div className="background-modal-overlay" role="presentation">
          <section
            className="background-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="background-modal-title"
          >
            <header className="background-modal-header">
              <div>
                <span>Personalização</span>
                <h2 id="background-modal-title">Fundo da página inicial</h2>
                <p>Escolha a imagem exibida atrás dos eventos públicos.</p>
              </div>
              <button
                type="button"
                className="background-modal-close"
                onClick={closeBackgroundModal}
                aria-label="Fechar"
                disabled={isSavingBackground}
              >
                ×
              </button>
            </header>

            <div className="background-upload-field">
              <label htmlFor="background-image">Imagem de fundo</label>
              <div className="background-upload-control">
                <input
                  id="background-image"
                  type="file"
                  accept=".jpg,.jpeg,.png,.webp"
                  onChange={handleBackgroundFile}
                  disabled={isSavingBackground}
                />
                <span>JPG, PNG ou WEBP, com até 8 MB</span>
              </div>
            </div>

            {backgroundImg.previewUrl && (
              <div className="background-image-preview">
                <img src={backgroundImg.previewUrl} alt="Prévia do novo fundo" />
              </div>
            )}

            {backgroundError && (
              <p className="background-modal-error" role="alert">
                {backgroundError}
              </p>
            )}

            <footer className="background-modal-actions">
              <button
                type="button"
                onClick={closeBackgroundModal}
                className="background-modal-secondary"
                disabled={isSavingBackground}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleSalvar}
                className="background-modal-primary"
                disabled={!backgroundImg.file || isSavingBackground}
              >
                {isSavingBackground ? "Salvando..." : "Salvar alteração"}
              </button>
            </footer>
          </section>
        </div>
      )}
    </>
  );
};

export default Menu;
